import { BRIEF_EMAIL } from '../lib/brief'

const navLinks = [
  { name: 'Services', href: '#services' },
  { name: 'Work', href: '#work' },
  { name: 'How we work', href: '#how-we-work' },
  { name: 'About', href: '#about' },
  { name: 'Start a brief', href: '#brief' },
]

export default function Footer() {
  return (
    <footer className="bg-[#081530] text-mist">
      <div className="container mx-auto px-6 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <a href="#top" className="site-focus flex items-center gap-3 text-white">
            <span className="w-9 h-9 bg-vault text-mariner font-brandSerif font-semibold text-xl flex items-center justify-center rounded-sm" aria-hidden="true">
              R
            </span>
            <span className="font-brandSerif font-semibold text-lg">Rozitech</span>
          </a>
          <p className="mt-6 max-w-sm leading-relaxed">
            Senior software engineering for banks, fintechs, healthcare and SaaS companies.
          </p>
        </div>

        <nav aria-label="Footer" className="md:col-span-3">
          <p className="site-label text-vault">Site</p>
          <ul className="mt-5 space-y-3">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="site-focus hover:text-white transition-colors duration-150 ease-out">
                  {l.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-4">
          <p className="site-label text-vault">Contact</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a href={`mailto:${BRIEF_EMAIL}`} className="site-focus hover:text-white transition-colors duration-150 ease-out">
                {BRIEF_EMAIL}
              </a>
            </li>
            <li>
              <a
                href="https://za.linkedin.com/in/gawie-van-blerk-2a1a685"
                target="_blank"
                rel="noreferrer"
                className="site-focus hover:text-white transition-colors duration-150 ease-out"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ledger">
        <div className="container mx-auto px-6 py-6 flex flex-col sm:flex-row gap-3 justify-between text-sm">
          <p>&copy; {new Date().getFullYear()} Rozitech (Pty) Ltd. All rights reserved.</p>
          <p className="font-brandMono text-[12px] uppercase tracking-[0.12em]">South Africa · Since 1999</p>
        </div>
      </div>
    </footer>
  )
}
